import React from 'react';
import { TileGroup, Tile } from 'components/layout/tiles';
import { CalendarDaysIcon, CalendarIcon, ClockIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import { REMINDER_FREQUENCIES } from 'constants/reminders';

export default function RepeatingFrequencyStep() {
  const { nextStep, data } = useWizard();

  const handleSelect = (frequency) => {
    nextStep({ frequency });
  };

  return (
    <WizardStepLayout
      title="Select Frequency"
      description="How often should this reminder repeat?"
    >
      <TileGroup className="sm:grid-cols-2">
        <Tile
          title="Daily"
          description="Repeat every day at a specific time."
          icon={ClockIcon}
          selected={data.frequency === REMINDER_FREQUENCIES.DAILY}
          onClick={() => handleSelect(REMINDER_FREQUENCIES.DAILY)}
        />
        <Tile
          title="Weekly"
          description="Repeat on specific days of the week."
          icon={CalendarDaysIcon}
          selected={data.frequency === REMINDER_FREQUENCIES.WEEKLY}
          onClick={() => handleSelect(REMINDER_FREQUENCIES.WEEKLY)}
        />
        <Tile
          title="Monthly"
          description="Repeat on a specific day of the month."
          icon={CalendarIcon}
          selected={data.frequency === REMINDER_FREQUENCIES.MONTHLY}
          onClick={() => handleSelect(REMINDER_FREQUENCIES.MONTHLY)}
        />
        <Tile
          title="Annual"
          description="Repeat once a year on a specific date."
          icon={ArrowPathIcon}
          selected={data.frequency === REMINDER_FREQUENCIES.ANNUAL}
          onClick={() => handleSelect(REMINDER_FREQUENCIES.ANNUAL)}
        />
      </TileGroup>
    </WizardStepLayout>
  );
}
